import React from "react";
import { toastr } from "react-redux-toastr";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel, InputGroup } from "react-bootstrap";
import { companyService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import Loading from "components/Loading";

class ChangeOwnerEmailModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			isSaving: false,
			owner: null,
			email: "",
			errors: {},
		};
	}

	async componentDidMount() {
		const response = await companyService.getOwner(
			this.props.partner_company.id
		);
		if (response.ok) {
			this.setState({
				owner: response,
				email: response.email || "",
				isLoading: false,
			});
		} else {
			this.setState({ isLoading: false });
		}
	}

	handleSubmit = async () => {
		const { owner, email } = this.state;
		const { t } = this.props;
		const companyId = this.props.partner_company.id;

		this.setState({ isSaving: true, errors: {} });

		const response = await companyService.updatePartnerEmployee(
			companyId,
			owner.id,
			{ ...owner, email }
		);

		if (response.ok) {
			this.setState({ owner: { ...owner, email }, isSaving: false });
			toastr.success(t("common.success"), t("common.changesSaved"));
			this.props.handleClose();
		} else {
			this.setState({ isSaving: false, errors: errorFormating(response) });
		}
	};

	render() {
		const { isLoading, isSaving, owner, email, errors } = this.state;
		const { t } = this.props;

		if (isLoading)
			return (
				<div className="modal-body">
					<Loading />
				</div>
			);

		if (!owner) {
			return (
				<div className="modal-body">
					<p className="text-muted">
						{t("subscriptionsPage.ownerNotFound")}
					</p>
				</div>
			);
		}

		return (
			<>
				<div className="modal-body">
					<p>
						<strong>{t("subscriptionsPage.company")}:</strong> {this.props.partner_company.name}
					</p>
					<p>
						<strong>{t("subscriptionsPage.owner")}:</strong> {owner.name} {owner.surname}
					</p>
					<FormGroup className="form-group mt30" controlId="ownerEmail">
						<FormLabel>Email</FormLabel>
						<FormControl
							type="email"
							value={email}
							onChange={(e) => this.setState({ email: e.target.value })}
							isInvalid={!!errors.email}
						/>
						<FormControl.Feedback type="invalid">
							{errors.email}
						</FormControl.Feedback>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{t("common.close")}
					</button>
					<SubmitButton
						type="button"
						isLoading={isSaving}
						text={t("common.save")}
						loadingText={t("common.saving")}
						onClick={this.handleSubmit}
					/>
				</div>
			</>
		);
	}
}

export default withTranslation()(ChangeOwnerEmailModal);
